import { render, staticRenderFns } from "./gdpr.vue?vue&type=template&id=51e2246b&scoped=true&"
import script from "./gdpr.vue?vue&type=script&lang=js&"
export * from "./gdpr.vue?vue&type=script&lang=js&"
import style0 from "./gdpr.vue?vue&type=style&index=0&id=51e2246b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e2246b",
  null
  
)

export default component.exports